/**
 * Minimal Google Analytics (gtag.js) helper.
 * The <Analytics /> component loads gtag.js; this file exposes a typed
 * tracker that no-ops if gtag isn't on the page yet.
 */

declare global {
  interface Window {
    gtag?: (
      command: 'config' | 'event' | 'set' | 'js',
      target: string | Date,
      params?: Record<string, unknown>,
    ) => void
  }
}

export const EVT = {
  PAGE_VIEW: 'page_view',
  RATE_SUBMIT: 'rate_submit',
  CHALLENGE_VOTE: 'challenge_vote',
  SIGN_UP: 'sign_up',
  LOGIN: 'login',
  BEST_OF_FILTER: 'best_of_filter',
  IMAGE_UPLOAD: 'image_upload',
} as const

export type EventName = typeof EVT[keyof typeof EVT]

export function track(name: EventName, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', name, params)
}

export {}
